import { estateAccountingQuebecDistributions } from './estateaccountingquebecdistribution.state';
import { EstateAccountingQuebecDistribution } from '@/modules/estateaccountingquebecdistribution/models/EstateAccountingQuebecDistribution';

export function getDistributions(): EstateAccountingQuebecDistribution[] {
  return estateAccountingQuebecDistributions.value ?? [];
}
